<template>
      <div class="locationEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'location', params: {} }">
          Location
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'locationEdit', params:{id: id} }">
            Edit Location
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Location</v-card-title>
          <v-card-text>
            <location-form :id="id"></location-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import LocationForm from './LocationForm.vue';

    export default {
      name: 'location',
      data () {
        return {
          id: null
        }
      },
      components: {
        LocationForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    